<template>
    <div
        class="wft-row" 
        @click="$router.push({name: 'engineer.forms.edit', params: {id: form.id}})"
    >
        <div class="wft-header">
            <span>{{ form.test_date | date }}</span>
        </div>
        <div class="wft-body">
            <p><strong>Vehicle:</strong> {{ form.vehicle_reg }}</p>
            <p><strong>Engineer</strong>: {{ form.engineer ? form.engineer.name : '-' }}</p>
            <p><strong>Test Date:</strong> {{ form.test_date | date }}</p>
            <router-link
                :to="{name: 'engineer.forms.edit', params: {id: form.id}}"
                class="btn btn-info"
            >
                View
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        form: {
            type: Object,
            required: true,
        }
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/engineer/WeeklyFunctionalTestRow.vue